import { request, setAuthToken } from '@reflex/ui/client/http';
import type { EmailRegistrationStatus } from '@reflex/shared';

/**
 * Browser-side client for the plugin's public `/auth/email/*` routes. Lives in
 * the plugin (not core `web/`) so the email surface owns its own transport,
 * and uses the browser-safe `@reflex/ui/client/http` primitives. A successful
 * login or registration returns a session token which we persist via
 * `setAuthToken` so subsequent requests carry `Authorization: Bearer ...`.
 */

interface EmailAuthResult {
  ok: boolean;
  token: string;
}

/** Whether self-service registration is currently allowed on the login page. */
export function getEmailRegistrationStatus(): Promise<EmailRegistrationStatus> {
  return request<EmailRegistrationStatus>('/auth/email/registration');
}

export async function emailLogin(email: string, password: string): Promise<EmailAuthResult> {
  const result = await request<EmailAuthResult>('/auth/email/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  if (result.token) setAuthToken(result.token);
  return result;
}

export async function emailRegister(input: {
  email: string;
  password: string;
  name?: string;
}): Promise<EmailAuthResult> {
  const result = await request<EmailAuthResult>('/auth/email/register', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  if (result.token) setAuthToken(result.token);
  return result;
}
